import UploadSection from "./src/uploadSection";
import ParticipantUploads from "./src/participantUploads";
import CoachUploads from "./src/participantCoach";
import React from "react";
import NoEditableFileMessage from "./src/noEditableFileMessage";
import Section from "../../../components/section/section";

const ParticipantFilesContainer = (): React.JSX.Element => (
  <React.Fragment>
    <Section>
      <NoEditableFileMessage />
      <UploadSection />
    </Section>

    <Section>
      <ParticipantUploads />
      <CoachUploads />
    </Section>
  </React.Fragment>
);

export default ParticipantFilesContainer;
